import { MoteLogo } from '@mote/assets/logo'
import styled, { th } from '@xstyled/styled-components'
import { Tooltip } from '../TooltipV2'
import { Button } from '../button'

export interface MotoLogoButtonProps {
  href: string
}

export const MOTE_LOGO_BUTTON_CSS_CLASS = 'mote-logo-button'

export const MoteLogoButton = (props: MotoLogoButtonProps): JSX.Element => {
  return (
    <div>
      <StyledButton
        //@ts-expect-error
        className={MOTE_LOGO_BUTTON_CSS_CLASS}
        size='sm'
        variant='ghost'
        href={props.href}
        icon={<MoteLogo />}
        target='_blank'
        data-for='moteLogoButtonTooltip'
        data-tip
      />
      <Tooltip place='top' id='moteLogoButtonTooltip'>
        View on mote.com
      </Tooltip>
    </div>
  )
}

const StyledButton = styled(Button)`
  display: inline-flex !important;

  .button-icon {
    svg circle {
      fill: ${th.color('grey.l3')};
      transition: fill 150ms ease-in;
    }
  }

  &:hover,
  &:focus {
    .button-icon {
      svg circle {
        fill: ${th.color('primary.base')};
      }
    }
  }
`
